/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AddFirmManagerToClientRequest,
  ClientResponse,
  CreateClientRequest,
  CreateFirmReferralRequest,
  EnrichedClientPageResponse,
  FirmReferralPageResponse,
  FirmReferralResponse,
  InviteUserRequest,
  SearchClientRequest,
  SearchFirmReferralRequest,
  ValidateFirmReferralRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FirmController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags firm-controller
   * @name InviteUser
   * @request POST:/api/v1/accounting-firms/users/invites
   */
  inviteUser = (data: InviteUserRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/accounting-firms/users/invites`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static inviteUserPath = '/v1/accounting-firms/users/invites'
  static inviteUserMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name CreateClient
   * @request POST:/api/v1/accounting-firms/clients
   */
  createClient = (data: CreateClientRequest, params: RequestParams = {}) =>
    this.http.request<ClientResponse, any>({
      path: `/v1/accounting-firms/clients`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createClientPath = '/v1/accounting-firms/clients'
  static createClientMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name SearchClient
   * @request POST:/api/v1/accounting-firms/clients/search
   */
  searchClient = (data: SearchClientRequest, params: RequestParams = {}) =>
    this.http.request<EnrichedClientPageResponse, any>({
      path: `/v1/accounting-firms/clients/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchClientPath = '/v1/accounting-firms/clients/search'
  static searchClientMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name CreateFirmReferral
   * @request POST:/api/v1/accounting-firm/referrals
   */
  createFirmReferral = (data: CreateFirmReferralRequest, params: RequestParams = {}) =>
    this.http.request<FirmReferralResponse, any>({
      path: `/v1/accounting-firm/referrals`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createFirmReferralPath = '/v1/accounting-firm/referrals'
  static createFirmReferralMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name ValidateFirmReferral
   * @request POST:/api/v1/accounting-firm/referrals/validate
   */
  validateFirmReferral = (data: ValidateFirmReferralRequest, params: RequestParams = {}) =>
    this.http.request<FirmReferralResponse, any>({
      path: `/v1/accounting-firm/referrals/validate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static validateFirmReferralPath = '/v1/accounting-firm/referrals/validate'
  static validateFirmReferralMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name SearchFirmReferral
   * @request POST:/api/v1/accounting-firm/referrals/search
   */
  searchFirmReferral = (data: SearchFirmReferralRequest, params: RequestParams = {}) =>
    this.http.request<FirmReferralPageResponse, any>({
      path: `/v1/accounting-firm/referrals/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchFirmReferralPath = '/v1/accounting-firm/referrals/search'
  static searchFirmReferralMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name AddFirmManagerToClient
   * @request POST:/api/v1/accounting-firm/clients/{clientOrganisationId}/managers
   */
  addFirmManagerToClient = (
    clientOrganisationId: string,
    data: AddFirmManagerToClientRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ClientResponse, any>({
      path: `/v1/accounting-firm/clients/${clientOrganisationId}/managers`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static addFirmManagerToClientPath = '/v1/accounting-firm/clients/${clientOrganisationId}/managers'
  static addFirmManagerToClientMethod = 'POST'
  /**
   * No description
   *
   * @tags firm-controller
   * @name RemoveFirmManagerFromClient
   * @request DELETE:/api/v1/accounting-firm/clients/{clientOrganisationId}/managers/{firmManagerUserId}
   */
  removeFirmManagerFromClient = (
    clientOrganisationId: string,
    firmManagerUserId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ClientResponse, any>({
      path: `/v1/accounting-firm/clients/${clientOrganisationId}/managers/${firmManagerUserId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    })

  static removeFirmManagerFromClientPath =
    '/v1/accounting-firm/clients/${clientOrganisationId}/managers/${firmManagerUserId}'
  static removeFirmManagerFromClientMethod = 'DELETE'
}
